export const SET_EXPERTISESKILLS_DETAILS = '@gig/expertiseskills/details';

export const setExpertiseSkillsDetails = (data) => ({
  type: SET_EXPERTISESKILLS_DETAILS,
  payload: data
});
